module.exports = __webpack_public_path__ + "img/grid_classic.c2efb38e.png";